$(function () {
  if ($('.top-we__slider').length) {
    
    $('.top-we__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: true,
      autoplaySpeed: 2600,
      autoplay: false,
      infinite: true,
      dots: false,
      asNavFor: '.top-we__modal__slider',
      prevArrow:
        '<span class="prev-arrow">',
      nextArrow:
        '<span class="next-arrow">',
    });
    $('.top-we__modal__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: true,
      autoplaySpeed: 2600,
      autoplay: false,
      infinite: true,
      dots: false,
      asNavFor: '.top-we__slider',
      prevArrow:
        '<span class="prev-arrow">',
      nextArrow:
        '<span class="next-arrow">',
    });
  }
  
  $('.top-we__slider-item').on('click',function() {
    $('.top-we__modal').addClass('is-show');
  });
  $('.top-we__modal-close').on('click',function() {
    $('.top-we__modal').removeClass('is-show');
  });
  
  var count = 206;
 $('.FeaturedProduct  .ProductMeta__Description p').each(function() {
     var thisText = $(this).text();
      var textLength = thisText.length;
       if (textLength > count) {
          var showText = thisText.substring(0, count);
          var insertText = showText += '…';
          $(this).html(insertText);
      };
  });
  

//   $('.Header__Icon').on('click', function(){
//     var cartEmpty = $('.Cart__Empty');
//      if(cartEmpty.length){
//     console.log('@1');
//         $('.cart-attribute__field').css({opacity:"0",'pointer-events':"none"});
//     $('.Drawer__Footer').css({opacity:"0",'pointer-events':"none"});
//     } else{
//       console.log('@2');

//     }
//   });

  
  $('.CartItem__Remove').on('click', function(){
    var drawerMain = $('.Drawer__Main');
    console.log('@3');
//      if(drawerMain.find('.CartItem').length){
//     console.log('@1');
    
//     } else{
//       console.log('@2');
//       $('.cart-attribute__field').css({opacity:"0",'pointer-events':"none"});
//       $('.Drawer__Footer').css({opacity:"0",'pointer-events':"none"});
//     }
  });
 

  gsap.from(".top-about__image img",{
  scrollTrigger: {
      trigger: ".top-about__image",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  
gsap.from(".top-comingsoon__item.item01 img",{
  scrollTrigger: {
      trigger: ".top-comingsoon__item.item01 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  gsap.from(".top-comingsoon__item.item02 img",{
  scrollTrigger: {
      trigger: ".top-comingsoon__item.item02 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  gsap.from(".top-comingsoon__item.item03 img",{
  scrollTrigger: {
      trigger: ".top-comingsoon__item.item03 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
    gsap.from(".top-comingsoon__item.item04 img",{
  scrollTrigger: {
      trigger: ".top-comingsoon__item.item04 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
    gsap.from(".top-comingsoon__item.item05 img",{
  scrollTrigger: {
      trigger: ".top-comingsoon__item.item05 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  
  gsap.from(".concept-about__figure img",{
  scrollTrigger: {
      trigger: ".concept-about__figure",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.1,
  duration: 3,
});
  
  
  gsap.from(".concept-quality__item-image.item01 img",{
  scrollTrigger: {
      trigger: ".concept-quality__item-image.item01 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  gsap.from(".concept-quality__item-image.item02 img",{
  scrollTrigger: {
      trigger: ".concept-quality__item-image.item02 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
    gsap.from(".concept-quality__item-image.item03 img",{
  scrollTrigger: {
      trigger: ".concept-quality__item-image.item03 img",
      start: "top bottom",
      end: "bottom",
      scrub: true,
  },
  scale : 1.2,
  duration: 3,
});
  
  
  $('.top-comingsoon__deco').each(function () {
    var winH = $(window).height();
    var obj = $(this);
    var offset = obj.offset().top;
    pos = 0,
    $(window).scroll(function () {
    scroll = $(window).scrollTop();
    pos = (10 + (offset - scroll) / winH) * 0.01 * 600;
    if (scroll > offset - winH) {
    obj.css('transform', 'translateX(' + pos + '%)');
    }
    });
});
    $('.top-comingsoon__deco-sp').each(function () {
    var winH = $(window).height();
    var obj = $(this);
    var offset = obj.offset().top;
    pos = 0,
    $(window).scroll(function () {
    scroll = $(window).scrollTop();
    pos = (10 + (offset - scroll) / winH) * 0.01 * 600;
    if (scroll > offset - winH) {
    obj.css('transform', 'translateX(' + pos + '%)');
    }
    });
});
  
    $('.top-we__deco').each(function () {
    var winH = $(window).height();
    var obj = $(this);
    var offset = obj.offset().top;
    pos = 0,
    $(window).scroll(function () {
    scroll = $(window).scrollTop();
    pos = (10 + (offset - scroll) / winH) * 0.01 * 600;
    if (scroll > offset - winH) {
    obj.css('transform', 'translateX(' + pos + '%)');
    }
    });
});
  

  
  
  $('.concept-quality__deco02').each(function () {
    var winH = $(window).height();
    var obj = $(this);
    var offset = obj.offset().top;
    pos = 0,
    $(window).scroll(function () {
    scroll = $(window).scrollTop();
    pos = (10 + (offset - scroll) / winH) * 0.01 * 1000;
    if (scroll > offset - winH) {
    obj.css('transform', 'translateX(' + pos + '%)');
    }
    });
});
  $('.concept-quality__deco01, .concept-quality__deco03').each(function () {
    var winH = $(window).height();
    var obj = $(this);
    var offset = obj.offset().top;
    pos = 0,
    $(window).scroll(function () {
    scroll = $(window).scrollTop();
    pos = (10 - (offset - scroll) / winH) * 0.01 * 1000;
    if (scroll > offset - winH) {
    obj.css('transform', 'translateX(' + pos + '%)');
    }
    });
});
  
  
   var target1 = $(".top-longimg, .concept-kv__image");
  var targetPosOT1 = target1.offset().top;
  var targetFactor = 0.1;
  var windowH = $(window).height();
  var scrollYStart1 = targetPosOT1 - windowH;
  $(window).on('scroll',function(){
    var scrollY = $(this).scrollTop();
    if(scrollY > scrollYStart1){
      target1.css('background-position-y', (scrollY - targetPosOT1) * targetFactor + 'px');
    }else{
      target1.css('background-position','left top');
    }
  });
  

});


